import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { primary, secondary, error } = theme.palette;
  const { md, sm } = theme.breakpoints;
  const { spacing, shadows } = theme;
  const priceWrapper = css`
    display: flex;
    gap: 10px;

    & p {
      margin: 0;
      font-weight: 400;
      font-size: 16px;
      line-height: 21px;
    }

    & .strikethrough {
      position: relative;
      color: ${primary.main};

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        border-top: 1px solid ${primary.main};
        left: 50%;
        bottom: 11px;
        transform: translate(-50%, 0%);
      }
    }

    & .price {
      color: ${primary.main};
    }

    & .free {
      color: ${secondary.light};
    }

    & .negative {
      color: ${error.light};
    }

    & .text-right {
      text-align: right;
    }
  `;

  return { priceWrapper };
};

export default useStyle;
